import {useCallback, useState} from "react";

export const useConfirmationModal = () => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [onConfirmAction, setOnConfirmAction] = useState(null);

  const openConfirmation = useCallback((message, onConfirm) => {
    setConfirmationMessage(message);
    setOnConfirmAction(() => onConfirm);
    setConfirmOpen(true);
  }, []);
  const closeConfirmation = useCallback(() => {
    setConfirmOpen(false);
    setOnConfirmAction(null);
  }, []);
  const handleConfirm = useCallback(() => {
    if (onConfirmAction) {
      onConfirmAction();
    }
    closeConfirmation();
  }, [onConfirmAction, closeConfirmation]);

  return {
    confirmOpen,
    confirmationMessage,
    openConfirmation,
    closeConfirmation,
    handleConfirm,
    setConfirmationMessage,
    setOnConfirmAction,
    setConfirmOpen,
  };
};
